import type { ActivatedRouteSnapshot } from '@angular/router';

export function findRouteParamInSnapshot(
    snapshot: ActivatedRouteSnapshot | null,
    paramName: string
): string | null {
    if (!snapshot) {
        return null;
    }

    const paramValue = snapshot.params[paramName];
    if (typeof paramValue === 'string' && paramValue.length > 0) {
        return paramValue;
    }

    for (const child of snapshot.children) {
        const childParamValue = findRouteParamInSnapshot(child, paramName);
        if (childParamValue) {
            return childParamValue;
        }
    }

    return null;
}
